import {
  apiGet, apiPost,
} from '~/_shared/utils/api/api.helpers';
import type { DataLayerData } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export type DataLayerTemplateId = number;

export type DataLayerTemplateResponse = Readonly<{
  id: DataLayerTemplateId;
  data: DataLayerData;
}>;

export type DataLayerTemplatesListResponse = Readonly<{
  data: ReadonlyArray<DataLayerTemplateResponse>;
}>;

export type CreateDataLayerTemplateRequest = Readonly<{
  data: DataLayerData;
}>;

export type CreateDataLayerTemplateResponse = Readonly<{
  data: DataLayerTemplateResponse;
}>;

export const getDataLayerTemplates = (clientId: number): Promise<DataLayerTemplatesListResponse> => {
  const requestUrl = `/api/clients/${clientId}/data-layer-templates`;

  return apiGet(requestUrl);
};

export const createDataLayerTemplate = (clientId: number, dataLayer: DataLayerData): Promise<CreateDataLayerTemplateResponse> => {
  const requestUrl = `/api/clients/${clientId}/data-layer-templates`;

  const request: CreateDataLayerTemplateRequest = {
    data: dataLayer,
  };

  return apiPost(requestUrl, request);
};
